import pl from "./subscriptions/pl.json";
import en from "./subscriptions/en.json";

export default {
  pl,
  en,
};
